export default __webpack_public_path__ + "static/media/bar3Animation.542b2cce.svg";